import React from 'react'
import {BsLinkedin, BsGithub, BsDribbble} from 'react-icons/bs'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/in/tariq-kharsa-7a2546116/" rel="noreferrer" target="_blank"><BsLinkedin/></a>
        <a href="https://github.com/Tariqkharsa?tab=repositories" rel="noreferrer" target="_blank"><BsGithub/></a>
        <a href="https://dribbble.com/Tariqkharsa" rel="noreferrer" target="_blank"><BsDribbble/></a>
    </div>
  )
}

export default HeaderSocials

// 1 hour and 7 minutes and 9 seconds